const visualisationConfig = {
    coloursForRegl: {
        plague: [(87 / 255), (131 / 255), 0],
        upsurge: [(153 / 255), (188 / 255), (102 / 255)],
        recession: [(249 / 255), (211 / 255), (21 / 255)],
    },
    colorsBarChart: {
        plague: '#578300',
        upsurge: '#99BC66',
        recession: '#F9D315',
    },
    graphMargins: {
        left: 100,
        top: 50,
        right: 100,
        bottom: 0,
    },
    dataTypes: ['plague', 'upsurge', 'recession'],
    breakpoint: 700,
};

export default visualisationConfig;
